module.exports = __webpack_public_path__ + "static/media/hero-bcg-2.64f4f610.jpeg";